import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { AssistListResp } from "domain/payload/response/assist/AssistListResp";
import { AssistDetailResp } from "domain/payload/response/assist/AssistDetailResp";
import { AssistTypeListResp } from "domain/payload/response/assist/AssistTypeListResp";
import { FieldVisitAssistListResp } from "domain/payload/response/assist/FieldVisitAssistListResp";
import { FieldVisitAssistDetailResp } from "domain/payload/response/assist/FieldVisitAssistDetailResp";
import { FieldVisitAssistConfigResp } from "domain/payload/response/assist/FieldVisitAssistConfigResp";

const AssistService = () => {
  const assistChangePhoneList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null,
    status?: "check" | "history"
  ): Promise<BaseResponse<AssistListResp[]>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/assist/partner-phone-change/list`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, size, search, status },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const assistTypeList = async (
    token: string
  ): Promise<BaseResponse<AssistTypeListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/assist/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const assistDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<AssistDetailResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/assist/partner-phone-change/detail`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const assistDecision = async (
    token: string,
    id: string,
    status: string
  ): Promise<BaseResponse<{ message: string; reqId: string; status: string }>> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/assist/partner-phone-change/decision`,
        { id, status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const assistFieldVisitList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null,
    projectId?: string | null,
    visitType?: "witness" | "backcheck" | "other" | null,
    dateFrom?: string | null,
    dateTo?: string | null
  ): Promise<BaseResponse<BaseResponse<FieldVisitAssistListResp[]>>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/assist/field-visit/list`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, size, search, projectId, visitType, dateFrom, dateTo },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };
  
  const assistFieldVisitDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<FieldVisitAssistDetailResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/assist/field-visit/detail`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };
  
  const assistFieldVisitConfig = async (
    token: string
  ): Promise<BaseResponse<FieldVisitAssistConfigResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/assist/field-visit/config`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };


  return {
    assistChangePhoneList,
    assistTypeList,
    assistDetail,
    assistDecision,
    assistFieldVisitList,
    assistFieldVisitDetail,
    assistFieldVisitConfig,
  };
};

export default AssistService;
